module.exports = __webpack_public_path__ + "static/media/noVoucher.334f8644.svg";